import { AsyncPipe, NgIf } from '@angular/common';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';
import { MomentModule } from 'ngx-moment';
import { ConfigService } from '../../../shared/services/config.service';
import { TransportJobReportStoreService } from '../transport-job-report-store.service';
import { map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { ReportService } from '../../shared/services/report.service';
import { DOCUMENT } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TitleCasePipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-transport-job-table',
  templateUrl: './transport-job-table.component.html',
  standalone: true,
  imports: [
    NgIf,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    AsyncPipe,
    MomentModule,
    MatPaginator,
    MatSort,
    MatIcon,
    MatButtonModule,
    TitleCasePipe,
    MatTooltip,
    RouterLink
  ]
})
export class TransportJobTableComponent {
  help = {};
  results$ = this.store.datasource$;
  loading$ = this.store.loadingResults$;
  pagination$ = this.store.pagination$;
  total$ = this.pagination$.pipe(map((pagination) => pagination.count));
  pageSize$ = this.pagination$.pipe(map((pagination) => pagination.perPage));
  pageIndex$ = this.pagination$.pipe(map((pagination) => pagination.page));
  displayedColumns = [
    'id',
    'type',
    'created_at',
    'due',
    'resultant_completed_at',
    'actual_completed_at',
    'user_name',
    'customer_name',
    'deliverable_name',
    'location'
  ];

  dateFormat = ConfigService.dates.shortDateTimeFormat;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private store: TransportJobReportStoreService,
    private reportService: ReportService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  // Method to handle sorting changes
  onSortChange(event) {
    this.store.setSort({ sortBy: event.active, sortOrder: event.direction });
  }

  // Method to handle page changes
  onPageChange(event) {
    this.store.setPage({ page: event.pageIndex, perPage: event.pageSize });
  }

  excelExport() {
    this.store.filters$
      .pipe(
        take(1),
        tap((filter) => {
          console.log(filter);
        }),
        takeUntil(this.store.destroy$),
        switchMap((filter) => {
          console.log('attempting to export with', { filter });
          return this.reportService.exportTransportJobReport(filter);
        })
      )
      .subscribe((data: BlobPart) => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = this.document.createElement('a');
        a.href = url;
        a.download = 'transport-jobs.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }
}
